import { Application, Category } from '../providers/Applications.types';

type MappedApplications = {
  applications: Application[];
  category: Category;
};

export function mapApplicationsToCategories({
  applications,
  categories,
}: {
  applications: Application[];
  categories: Category[];
}): MappedApplications[] {
  let mapped: MappedApplications[] = categories.map((category) => {
    let applicationsInCategory = applications.filter(
      (application) => application.category === category.identifier,
    );
    applicationsInCategory = applicationsInCategory.sort(
      (a, b) => parseInt(a.position) - parseInt(b.position),
    );
    return { category, applications: applicationsInCategory };
  });
  mapped = mapped.sort((a, b) => parseInt(a.category.position) - parseInt(b.category.position));
  return mapped;
}
